import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
    Grid,
    CardContent,
    Card,
    List,
    ListItem,
    Typography,
} from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {},
    draggableList: {
        height:       '600px',
        background:   theme.palette.background.default,
        padding:      grid,
        borderRadius: '25px',
        overflow:     'auto',
    },
});

const grid = 8;

const getListStyle = (isDraggingOver) => {
    if (isDraggingOver) {
        return {
            background: 'lightblue',
        }
    }
};

class OrderAnswer extends Component {

    componentDidMount = () => {
        const { question } = this.props;
        
        this.props.initOrderAnswer(question.header.question_id, question.answerList);
    }

    onDragEnd = (result) => {
        const { question } = this.props;
        const { source, destination } = result;
        const question_id = question.header.question_id;
        
        if (!destination) {
            return;
        }
        
        this.props.orderStudentAnswer(source, destination, question_id);
    }

    generateAnswerCard = (answer, index, list_type) => {
        if (list_type === 'correct') {
            return (
                <Card style={{ width: '100%' }}>
                    <CardContent>
                        {`(${index+1}) - ${answer.header.AnswerText}`}
                    </CardContent>
                </Card>
            );
        } else {
            return (
                <Card style={{ width: '100%' }}>
                    <CardContent>
                        {answer.header.AnswerText}
                    </CardContent>
                </Card>
            );
        }
        
    }

    render() {
        const { classes, question, studentAnswers } = this.props;
        const question_id = question.header.question_id;

        if (typeof question === 'undefined' || !(question_id in studentAnswers)) {
            return <div>Loading...</div>
        }

        const answer_info = studentAnswers[question_id];

        return (
            <React.Fragment>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Grid container spacing={16}>
                        <Grid item xs={6}>
                            <Droppable droppableId="wrong">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={classes.draggableList}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        <Typography variant="h6" align="center">Select From the Following</Typography>
                                        <List>
                                            {answer_info.wrongList.map((answer, index) => (
                                                <Draggable
                                                    key={answer.header.answer_id}
                                                    draggableId={answer.header.answer_id}
                                                    index={index}
                                                    listType='wrong'
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}

                                                        >
                                                            <ListItem>
                                                                {this.generateAnswerCard(answer, index, 'wrong')}
                                                            </ListItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                        <Grid item xs={6}>
                            <Droppable droppableId="correct">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={classes.draggableList}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        <Typography variant="h6" align="center">Arrange in Correct Order</Typography>
                                        <List>
                                            {answer_info.correctList.map((answer, index) => (
                                                <Draggable
                                                    key={answer.header.answer_id}
                                                    draggableId={answer.header.answer_id}
                                                    index={index}
                                                    listType='correct'
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}

                                                        >
                                                            <ListItem>
                                                                {this.generateAnswerCard(answer, index, 'correct')}
                                                            </ListItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                    </Grid>
                </DragDropContext>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        selectAnswer:       Actions.selectAnswer,
        orderStudentAnswer: Actions.orderStudentAnswer,
        initOrderAnswer:    Actions.initOrderAnswer,
    }, dispatch);
}

function mapStateToProps({ quizApp }) {
    return {
        studentAnswers: quizApp.quizViewer.studentAnswers
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderAnswer)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/questionType/OrderAnswer.js